module.exports = __webpack_public_path__ + "static/media/arair.350e87f9.png";